import homeStore from './homeStore'
import commonStore from './commonStore'

const stores = {
    homeStore,
    commonStore
}

export default stores

export {
    homeStore
}


// WEBPACK FOOTER //
// ./src/stores/index.js